import { ToggleSidebarAction } from "~/reducers/utility";
import { TOGGLE_SIDEBAR_STATE } from "./types";

export const toggleSidebarState = (
  isSidebarExpanded: boolean
): ToggleSidebarAction => ({
  type: TOGGLE_SIDEBAR_STATE,
  isSidebarExpanded
});
